import { render, staticRenderFns } from "./ShopifyShipping.vue?vue&type=template&id=5071c77e&"
import script from "./ShopifyShipping.vue?vue&type=script&lang=js&"
export * from "./ShopifyShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ShopifyShipping.vue"
export default component.exports